import React from 'react';
import PropTypes from 'prop-types';

import Name from './Attributes/Name';
import Color from './Attributes/Color';
import Notifications from './Attributes/Notifications';
import AutoDelete from './Attributes/AutoDelete';

import { strings } from 'APP_ROOT/localization';

export default class GeneralAttributes extends React.Component {

    render () {

        const { geofenceId, stage, editable } = this.props;

        return (
            <section className="general-attributes">

                <section>

                    <Name geofenceId={geofenceId} stage={stage} editable={editable} />

                    <Color geofenceId={geofenceId} stage={stage} editable={editable} />

                    <AutoDelete geofenceId={geofenceId} stage={stage} pokeMap={this.props.pokeMap} editable={editable} />

                    <Notifications geofenceId={geofenceId} stage={stage} editable={editable} />

                </section>

            </section>
        )
    }
}

GeneralAttributes.protoTypes = {
    color: PropTypes.string, // a CSS color value (HEX, RGBA, HSL (function notation) etc, https://developer.mozilla.org/en-US/docs/Web/CSS/color_value)
    colorStatus: PropTypes.string,
    onColorChange: PropTypes.func.isRequired
}
